import { render, staticRenderFns } from "./TaskNew.vue?vue&type=template&id=66ebf9cc&scoped=true&"
import script from "./TaskNew.vue?vue&type=script&lang=js&"
export * from "./TaskNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebf9cc",
  null
  
)

export default component.exports